import { FC, useState } from 'react';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from 'assets/images/logo-alt.svg';
import { ReactComponent as FacebookIcon } from 'assets/icons/facebook.svg';
import { ReactComponent as TwitterIcon } from 'assets/icons/twitter.svg';
import { ReactComponent as InstagramIcon } from 'assets/icons/instagram.svg';
import { ReactComponent as YouTubeIcon } from 'assets/icons/youtube.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg';
import Input from '../Input';
import Button from '../Button';

const Footer: FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <footer className="bg-primary-3 xl:[clip-path:polygon(0_15%,100%_0,100%_100%,0%_100%)] pt-32">
      <div className="container mx-auto px-4 md:px-16">
        <div className="flex flex-col sm:justify-between lg:items-center lg:flex-row">
          <div className="shrink">
            <div className="inline-flex h-[118px] items-center justify-center">
              <Logo />
            </div>
            <p className="font-normal text-lg text-white lg:max-w-[340px]">
              Hello, we are Septagon. Our goal is to translate the positive
              effects from revolutionizing how companies engage with their
              clients & their team.
            </p>
          </div>
          <div className="mt-8 sm:mt-0">
            <div className="w-full">
              <p className="font-bold text-white text-lg">Join our community</p>
              <div className="flex mt-6 gap-8">
                <a
                  href="..."
                  className="inline-flex h-[35px] flex-none items-center justify-center"
                >
                  <FacebookIcon />
                </a>
                <a
                  href="..."
                  className="inline-flex h-[35px] flex-none items-center justify-center"
                >
                  <InstagramIcon />
                </a>
                <a
                  href="..."
                  className="inline-flex h-[35px] flex-none items-center justify-center"
                >
                  <TwitterIcon />
                </a>
                <a
                  href="..."
                  className="inline-flex h-[35px] flex-none items-center justify-center"
                >
                  <YouTubeIcon />
                </a>
              </div>
              <div className="inline-flex h-[94px] w-full bg-gray-2 px-12 mt-8 items-center justify-center">
                <div className="flex w-full items-center h-[50px]">
                  <Formik
                    initialValues={{ searchParams: '' }}
                    onSubmit={() => setOpen(false)}
                  >
                    <Form className="flex w-full h-full">
                      <Input
                        className="h-full rounded-l-[6px] outline-0 pl-4 w-full"
                        placeholder="Email address"
                      />
                      <Button
                        type="button"
                        className="bg-primary-3 rounded-l-none rounded-r-[6px]"
                      >
                        <ArrowRight />
                      </Button>
                    </Form>
                  </Formik>
                </div>
              </div>
              <p className="font-normal text-lg text-white mt-6">
                Kindly subscribe to our newsletter to get updates about listed
                properties and openings.
              </p>
              <div className="flex flex-col sm:flex-row justify-between mt-8 gap-y-4">
                <div className="flex flex-col gap-4">
                  <h6 className="text-xl font-semibold text-white">Product</h6>
                  <ul className="text-white flex flex-col gap-6">
                    <li>Lands</li>
                    <li>Islands</li>
                    <li>Estates</li>
                  </ul>
                </div>
                <div className="flex flex-col gap-4">
                  <h6 className="text-xl font-semibold text-white">
                    Information
                  </h6>
                  <ul className="text-white flex flex-col gap-3">
                    <li>FAQ</li>
                    <li>Blog</li>
                    <li>Support</li>
                  </ul>
                </div>
                <div className="flex flex-col gap-4">
                  <h6 className="text-xl font-semibold text-white">Company</h6>
                  <ul className="text-white flex flex-col gap-3">
                    <li>About us</li>
                    <li>Partners</li>
                    <li>Contact us</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between w-full flex-wrap py-8 mt-8">
          <div className="flex">
            <p className="text-white text-base font-normal">
              &copy;{new Date(Date.now()).getFullYear()}. All rights reserved.
            </p>
          </div>
          <div className="flex gap-8">
            <Link to="/terms" className="text-base text-white font-normal">
              Terms of Service
            </Link>
            <Link to="/policy" className="text-base text-white font-normal">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
